import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & {
  reversed?: boolean;
};

const Chevron = createComponent<OwnProps>('svg', props => ({
  className: cx('-:stroke-blue-2', { 'rotate-180': props.reversed })
}));

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <Chevron
    viewBox="0 0 16 17"
    height={16}
    width={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M5 14.6924L12 8.69238L5 2.69238"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Chevron>
));
